import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as SolidIcons from "@fortawesome/free-solid-svg-icons";
import { split, join, map, capitalize } from "lodash";

export function DashboardTitle(props) {
  const { title, imageSrc, bgColor, color, subTitle = "" } = props;
  const hypenToCapCase = (val) => {
    const arr = split(val, "-");
    const updatedArr = map(arr, (str) => capitalize(str));
    return join(updatedArr, "");
  };
  return (
    <div className="flex justify-content-between align-items-center gap-2">
      {imageSrc && (
        <div
          className="p-avatar p-component p-avatar-image p-avatar-circle"
          style={bgColor ? { background: bgColor } : {}}
          data-pc-name="avatar"
          data-pc-section="root"
        >
          {imageSrc.includes("/") ? (
            <img alt="avatar" src={imageSrc} data-pc-section="image" />
          ) : (
            <FontAwesomeIcon
              icon={SolidIcons["fa" + hypenToCapCase(imageSrc)]}
            />
          )}
        </div>
      )}
      <div className="flex gap-2 align-items-end">
        <h3 style={{ margin: '0px !important' }}>
          <b>{title}</b>
        </h3>
        {subTitle && <span className="text-xx text-gray-500">({subTitle})</span>}
      </div>
    </div>
  );
}
